import {
  PolicyContainer,
  PolicyTitle,
  PolicyVersion,
  PolicyText,
  PolicyList,
  PolicySectionTitle,
  PolicyArticleTitle,
  PolicyHyphenList,
} from "styles/PolicyCommon";

const Operation = () => {
  return (
    <PolicyContainer>
      <h1 className="hide">열달후에</h1>
      <PolicyTitle>[열달후에] 커뮤니티 ‘열달맘톡’ 운영원칙</PolicyTitle>
      <PolicyVersion>ver.2.1</PolicyVersion>

      <PolicyText>
        본 운영원칙은 ‘커넥트아이’(이하 ‘회사’)가 제공하는 ‘열달후에’ 서비스 내
        ‘열달맘톡’ 커뮤니티를 운영함에 있어, 서비스 내에서 발생할 수 있는 문제
        상황에 대하여 일관성 있게 대처하기 위하여 ‘열달후에 이용약관’에 따라
        서비스에 대한 구체적인 내용 및 이용자가 준수해야 할 사항, 이용자에 대한
        서비스 제한 등 세부사항을 규정합니다.
        <br />
        운영원칙을 지키지 않을 경우 불이익을 당할 수 있으니 주의 깊게 읽어
        주시기 바랍니다.
      </PolicyText>

      <PolicyText>
        <strong>
          ‘열달맘톡’은 여성들의 고민이나 다양한 주제의 이야기를 많은 사람들과
          나눌 수 있는 서비스입니다. 여성 전용 커뮤니티 ‘열달맘톡’은 이렇게
          이용해 주세요.
        </strong>
      </PolicyText>

      <PolicySectionTitle>1. 프로필 정보는 나의 얼굴입니다.</PolicySectionTitle>
      <PolicyText>
        나를 표현할 수 있도록 프로필 정보(닉네임, 프로필 사진)를 만들어 주세요.
        <br />
        프로필 정보 내용이 아래 내용에 해당하는 경우, 이용이 제한될 수 있습니다.
      </PolicyText>
      <PolicyHyphenList>
        <li>부적절한 내용이나 이미지를 포함하는 경우</li>
        <li>
          다른 단체나 개인이 권리를 보유한 브랜드를 도용하거나 기업, 단체, 인물
          등을 사칭하는 경우
        </li>
        <li>관리자를 사칭하는 등 서비스 이용에 혼란을 줄 수 있는 경우</li>
      </PolicyHyphenList>

      <PolicySectionTitle>2. 게시물은 이렇게 작성해 주세요.</PolicySectionTitle>
      <PolicyText>
        열달맘톡에서 작성되는 게시물은 본인인증을 받은 여성 회원 모두가 볼 수
        있으므로 작성한 게시물이 ‘열달후에’ 서비스 이용약관의 제10조 3항 ‘게재
        불가 게시물’에 해당하지 않는지 항상 확인해 주세요.
      </PolicyText>

      <PolicySectionTitle>3. 게시물이 불편하다면?</PolicySectionTitle>
      <PolicyText>
        광고, 홍보 목적, 남을 비방하는 행위 등의 불편한 게시물 또는 댓글을
        확인하셨다면 신고 기능을 통해 더욱 쾌적한 커뮤니티를 만들어갈 수
        있습니다.
      </PolicyText>

      <PolicySectionTitle>
        4. 게시물의 노출과 서비스 이용이 제한될 수 있습니다.
      </PolicySectionTitle>
      <PolicyText>
        열달맘톡은 다양한 주제와 특별한 이야기로 많은 사람들에게 유익한 정보를
        제공하고 커뮤니케이션할 수 있도록 아래와 같은 기준으로 운영하고
        있습니다.
      </PolicyText>
      <PolicyArticleTitle>가. 금지행위</PolicyArticleTitle>
      <PolicyText>
        ‘열달후에’ 서비스 이용약관, 본 운영원칙, 방송통신심의위원회의 정보통신에
        관한 심의규정 및 청소년보호위원회 심의규정에 따라 아래와 같은 정보를
        포함하는 게시물을 ‘게재 불가 게시물’로 정의하며, 이러한 게시물을
        게재하거나 기타 금지행위를 하는 경우 게시물의 노출 및 서비스의 이용을
        제한하고 있습니다.
      </PolicyText>
      <PolicyList>
        <li>
          <strong>① 음란성 게시물</strong>
          <br />
          <PolicyHyphenList>
            <li>과도한 신체 노출이나 음란한 행위를 묘사하는 경우</li>
            <li>성 매매 관련 정보를 공유하는 경우</li>
            <li>
              타인에게 성적 수치심이나 불쾌감을 유발할 수 있는 내용을 포함한
              경우
            </li>
          </PolicyHyphenList>
        </li>
        <li>
          <strong>② 불법성 게시물</strong>
          <br />
          <PolicyHyphenList>
            <li>
              불법 사행성, 도박 사이트를 홍보하거나 사행심을 조장하는 경우
            </li>
            <li>불법 제품 또는 인터넷에서 판매 금지된 물품을 홍보하는 경우</li>
            <li>
              범법 행위에 대한 동기 부여 및 실행에 도움이 되는 정보를 제공하는
              경우
            </li>
          </PolicyHyphenList>
        </li>
        <li>
          <strong>③ 청소년 유해물</strong>
          <br />
          <PolicyHyphenList>
            <li>
              공서양속에 저해되는, 일반 사람들이 보기에 혐오스럽고 눈살이
              찌푸려지는 사진 또는 내용 (예:인간/동물의 사체 또는 훼손된 모습,
              방뇨/배설 장면, 살인/자살의 장면 등)
            </li>
            <li>
              합리적인 이유 없이 성별, 종교, 장애, 연령, 사회적 신분, 인종,
              지역, 직업 등을 차별하거나 이에 대한 편견을 조장하는 내용
            </li>
          </PolicyHyphenList>
        </li>
        <li>
          <strong>④ 광고/홍보성 게시물</strong>
          <br />
          열달맘톡 내 상업/홍보 활동을 통해 발생된 자발적 거래행위 등에 대해
          회사는 책임지지 않으며 이와 관련한 분쟁에 관여하지 않으니 이 경우 발견
          즉시 신고해주시기 바랍니다.
        </li>
        <li>
          <strong>⑤ 명예 훼손 게시물</strong>
          <br />
          <PolicyHyphenList>
            <li>개인의 사생활, 초상권을 침해한 경우</li>
            <li>
              개인이나 단체에 대해 비방하거나 허위사실을 유포한 경우 또는 권리를
              침해한 경우
            </li>
            <li>
              욕설 또는 언어폭력 등의 저속한 표현으로 특정인의 인격을 모독하거나
              불쾌감을 불러일으키는 경우
            </li>
          </PolicyHyphenList>
        </li>
        <li>
          <strong>⑥ 악성코드 유포 게시물</strong>
          <br />
          <PolicyHyphenList>
            <li>
              악성코드, 바이러스 등 이용자의 서비스 환경을 저해하는 프로그램으로
              회사의 업무를 방해하는 프로그램을 수록하거나 설치 유도, 배포하는
              경우
            </li>
            <li>
              회사에서 제공하지 않은 비정상인 방법으로 대량의 글을 작성 및
              공유/유포하거나, 타인의 활동을 방해하는 경우
            </li>
          </PolicyHyphenList>
        </li>
        <li>
          <strong>⑦ 지적 재산권 위반 게시물</strong>
          <br />
          <PolicyHyphenList>
            <li>
              방송, 음원, 영화, 만화 등 타인의 저작물을 당사자의 동의 없이
              공유하는 경우
            </li>
            <li>
              타인의 저작물을 불법적인 경로로 획득할 수 있는 정보나 방법을
              제공하는 경우(예 : 무료다운로드, 프리서버, CD키 공유 등)
            </li>
            <li>
              타인의 권리에 속하는 상표권, 의장권 등을 무단으로 침해하는 경우
            </li>
            <li>
              열달맘톡 내 게시물(전체 및 일부), 사진, 이미지를 무단도용(불펌)한
              경우
            </li>
          </PolicyHyphenList>
        </li>
        <li>
          <strong>⑧ 개인정보를 요구하거나 외부 대화를 유도하는 게시물</strong>
          <br />
          <PolicyHyphenList>
            <li>댓글로 개인정보를 요구하는 경우</li>
            <li>개인정보를 포함한 내용을 게시하는 경우</li>
            <li>
              오픈 채팅방 등 외부 대화를 유도하거나 sns 등을 통한 다이렉트
              메시지를 유도하는 경우{" "}
            </li>
          </PolicyHyphenList>
        </li>
        <li>
          <strong>⑨ 통신판매 금지 품목, 제한 품목 관련 게시물</strong>
          <br />
          <PolicyText>
            현행 법률에서 인터넷을 통한 매매를 금지 및 제한하고 있는 품목을
            판매하거나 홍보 및 알선하는 경우
          </PolicyText>
          <PolicyHyphenList>
            <li>
              <strong>주류</strong>
              <br />
              [관련 법령] 주류의 통신판매에 관한 명령 위임 고시(국세청 고시
              제2005-5호) 제4호
            </li>
            <li>
              <strong>담배</strong>
              <br />
              [관련 법령] 담배 사업법 제12조 제4항
            </li>
            <li>
              <strong>마약 및 향정신성의약품</strong>
              <br />
              [관련 법령] 마약류 관리에 관한 법률 제28조 제1항
            </li>
            <li>
              <strong>의약품</strong>
              <br />
              [관련 법령] 약사법 제44조 및 제50조 제1항
            </li>
            <li>
              <strong>
                총포, 도검, 화약류, 분사기, 전자충격기, 석궁 및 총포와 비슷하게
                보이는 모의 총포
              </strong>
              <br />
              [관련 법령] 총포, 도검, 화약류 및 단속 법 제6조 제1항, 제11조
              제1항 및 동법 시행령 별표 5의2
            </li>
            <li>
              <strong>도수 있는 안경, 콘택트렌즈 및 선글라스</strong>
              <br />
              [관련 법령] 의료기사 등에 관한 법률 제9조 제1항 및 동법 시행령
              제2조 제8호
            </li>
            <li>
              <strong>
                안전 인증표시 없는 안전 인증 대상 전기용품 또는 공산품, 자율안전
                확인 신고의 표시 등이 없는 자율안전 확인 대상 전기용품 또는
                공산품, 어린이 보호 포장 표시가 없는 어린이 보호 포장 대상
                공산품
              </strong>
              <br />
              [관련 법령] 전기용품 안전 관리법 제7조 제1항, 품질경영 및
              공산품안전 관리법 제7조 제1항
            </li>
            <li>
              <strong>
                음란물, 청소년 유해 매체물, 청소년 유해약물, 청소년 유해물건(단,
                청소년 유해 매체물, 유해약물, 유해물건의 경우 청소년에게
                판매되는 경우에 한함)
              </strong>
              <br />
              [관련 법령] 형법 제243조 및 정보통신망 이용 촉진 및 정보 보호 등에
              관한 법률 제44조의 7 제1항 제1호, 청소년 보호법 제17조 제1항 및
              제26조 제1항
            </li>
            <li>
              <strong>상표권 침해물품, 소위 '짝퉁' 상품</strong>
              <br />
              [관련 법령] 상표법 제9조 제1항
            </li>
            <li>
              <strong>
                저작권, 초상권 및 성명권 침해 물품 및 심의되지 아니한 물품
              </strong>
              <br />
              [관련 법령] 저작권법 제136조 제1항, 헌법 제10조, 영화 및
              비디오물의 진흥에 관한 법률 제95조
            </li>
            <li>
              <strong>군복 및 군용물품</strong>
              <br />
              [관련 법령] 군복 및 군용장구의 단속에 관한 법률 제8조
            </li>
            <li>
              <strong>위해 식품, 병육, 고시되지 않은 화학적 합성품</strong>
              <br />
              [관련 법령] 식품위생법 제4조, 제5조, 제6조
            </li>
            <li>
              <strong>건강기능식품 및 의료기기</strong>
              <br />
              [관련 법령] 건강기능식품에 관한 법률 제6조 제2항, 의료기기 법
              제16조 제1항
            </li>
            <li>
              <strong>장물이나 습득한 유실물</strong>
              <br />
              [관련 법령] 형법 제360조 및 제362조
            </li>
            <li>
              <strong>
                멸종 위기 및 보호 야생 동식물, 가공품, 야생동물 포획 도구
              </strong>
              <br />
              [관계법령] 야생동식물 보호법 제9조, 제10조
            </li>
            <li>
              <strong>
                기타 관계법령에서 인터넷을 통한 매매를 금지하는 물품
              </strong>
              <br />
              철도 승차권, 사용제한 상품권 등 발행자가 전매를 금지한 물품을
              판매하거나 알선하는 경우
            </li>
          </PolicyHyphenList>
        </li>
        <li>
          <strong>⑩ 기타 금지 게시물</strong>
          <br />
          <ul>
            <li>
              특정 단어/문구를 반복 삽입하는 등의 비정상적인 게시물, 혹은
              프로그램 등을 이용하여 기계적인 패턴글로 도배하는 경우
            </li>
            <li>행운의 편지글, 스팸글, 홍보글 등의 도배자료를 게시하는 경우</li>
            <li>
              타인의 개인정보 노출/유도, 관리자 사칭 등 기타 회사의 서비스를 본
              목적에 어긋나게 사용하는 경우
            </li>
            <li>신고 등 이용자의 서비스 불편의 의사표시가 누적되는 경우</li>
          </ul>
        </li>
      </PolicyList>

      <PolicyArticleTitle>나. 서비스 이용의 제한 등</PolicyArticleTitle>
      <PolicyText>
        서비스 이용 제한의 기준 및 종류는 아래와 같고, 위반 행위의 누적 정도에
        게시물 블라인드에서 영구 제한까지 서비스의 이용이 단계적으로 제한되며,
        복수의 이용 제한이 동시에 적용될 수 있습니다.
      </PolicyText>
      <PolicyText>
        단, 음란성 게시물, 불법성/청소년 유해물, 현행법률(의료법, 학원법,
        대부업법, 부가가치세법, 전자상거래 등에서의 소비자보호에 관한 법률,
        간접투자자산운용업법, 저작권법, 상표법, 부정경쟁방지 및 영업비밀보호
        등에 관한 법률 등)을 위반하는 게시물의 작성 등과 같이 위반 행위의 정도가
        중대한 경우 위반 행위의 누적 정도와 관계없이 서비스 이용 중지, 활동
        제한, 영구 제한될 수 있습니다.
      </PolicyText>
      <PolicyText>
        회사가 서비스 이용을 제한하는 경우 회사는 이용자에게 계정(메일),
        서비스의 알림(앱 푸시, 조치 화면 등)으로 통지합니다.
      </PolicyText>
      <PolicyText>
        이용자는 서비스 이용 제한을 받은 날로부터 30일 이내에 회사에 대하여
        이의를 제기할 수 있습니다. 이의 제기는 &lt;열달후에 고객센터&gt;를 통해
        가능하며, 그 이후의 이의제기는 무효한 것으로 간주합니다.
      </PolicyText>

      <PolicyText>
        <strong>이용 제한 ID에 대한 정의</strong>
      </PolicyText>
      <PolicyList>
        <li>1. 본 운영원칙의 '가' 항목에서 정의한 금지된 게시글을 올리는 ID</li>
        <li>2. 본 운영원칙의 '가' 항목에서 금지하고 있는 행위를 한 ID</li>
        <li>3. 동일한 게시글 도배를 통해 다른 회원에게 불편을 주는 ID</li>
        <li>4. 다른 소모임에 특정 소모임에 대한 욕설과 비방을 하는 ID</li>
        <li>5. 기타 다른 방법으로 여러 회원에게 불쾌감을 주는 ID</li>
      </PolicyList>
      <PolicyText>
        위의 항목에 구체적으로 해당하지 않는 사항이라 하더라도 건전한 서비스
        환경 제공에 악영향을 끼치는 경우는 회사의 이용약관에 의거하여 서비스
        이용이 제한될 수 있습니다.
      </PolicyText>
      <PolicyText>
        본 운영원칙에 명시한 게시글을 게재하거나 금지된 이용행위를 한 ID에 대해
        다음과 같은 방법으로 이용 제한을 적용하고 있습니다.
      </PolicyText>

      <PolicyList>
        <li>
          <strong>① 게시물 블라인드 처리</strong>
          <PolicyHyphenList>
            <li>
              이용 제한 ID가 발견되거나 신고를 통해 접수되면 이용약관 및 본
              운영원칙에서 금지한 게시글은 통보 없이 즉시 삭제됩니다.
            </li>
            <li>
              블라인드 된 게시물은 다른 이용자들이 블라인드 된 사실을 알 수
              있도록 표시합니다.
            </li>
            <li>
              게시물 블라인드가 반복되는 경우 단계에 따라 활동 제한 등 다른
              제재가 동시에 적용될 수 있습니다.
            </li>
          </PolicyHyphenList>
        </li>
        <li>
          <strong>② 열달맘톡 소모임 이용 제한</strong>
          <PolicyHyphenList>
            <li>
              열달맘톡 내 특정 소모임에 작성한 게시물이 누적 3회 이상 블라인드
              처리되는 경우 해당 소모임 내에서 게시판 글쓰기 금지의 제한을
              받습니다.
            </li>
            <li>
              이용 제한 조치를 받고도 댓글 등을 통해 문제가 되는 이용 행위를
              중단하지 않은 ID는 자동으로 해당 소모임에서 영구 탈퇴 조치됩니다.
            </li>
          </PolicyHyphenList>
        </li>
        <li>
          <strong>③ 열달맘톡 전체 이용 제한</strong>
          <PolicyHyphenList>
            <li>
              이용약관 및 본 운영원칙에 위배되는 게시물을 다수 등록하여 누적 5회
              이상 블라인드 처리되는 경우 열달맘톡 내 모든 글쓰기 금지의 제한을
              받습니다.
            </li>
            <li>
              이용 제한 조치를 받고도 댓글 등을 통해 문제가 되는 이용 행위를
              중단하지 않은 ID는 자동으로 열달맘톡 접근이 제한됩니다.
            </li>
            <li>
              접근 제한 해제 신청는 고객센터를 통해 가능하며, 위반 행위 정도에
              따라 접근 제한 해제 또는 접근 제한 해제 거부가 결정됩니다.
            </li>
            <li>
              접근 제한이 해제된 이후 게시물이 1회 이상 블라인드 처리되는 경우
              해당 ID는 영구적으로 열달맘톡 이용이 제한됩니다.
            </li>
          </PolicyHyphenList>
        </li>
        <li>
          <strong>④ 서비스 계정 제한</strong>
          <PolicyHyphenList>
            <li>
              탈퇴, 재가입의 행위를 반복하며 게재 불가 게시물 등을 반복적으로
              게시한 이용 제한 ID의 경우 계정 소유자가 작성한 서비스 내 모든
              글이 삭제될 수 있습니다.
            </li>
            <li>
              탈퇴, 재가입의 행위를 반복하며 게재 불가 게시물 등을 반복적으로
              게시한 이용 제한 ID가 서비스에 막대한 피해를 끼쳤다고 판단될 경우
              해당 ID의 ‘열달후에’ 서비스 접근이 영구적으로 제한됩니다. 영구
              제한의 경우 탈퇴 후 재가입 시에도 동일한 주민등록번호로 생성된
              모든 ID에 대한 이용 제한 조치가 이루어질 수 있습니다.
            </li>
          </PolicyHyphenList>
        </li>
      </PolicyList>

      <PolicyText>
        ※ 본 운영원칙은 2022년 05월 16일부터 적용됩니다. 단, 본 운영원칙의 공지
        시점으로부터 적용일 전일까지 기간 동안에 가입한 신규회원에 대해서는 회원
        가입 시부터 본 운영원칙이 적용됩니다.
      </PolicyText>
    </PolicyContainer>
  );
};

export default Operation;
